import { useTranslation } from "react-i18next";
import { AreaToolbar } from "./AreaToolbar";
import { AreaList } from "./AreaList";

export const Areas = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="mb-6 p-6 rounded-xl bg-white shadow-sm">
        <h1 className="text-2xl font-bold mb-4">{t("products.title")}</h1>
        <AreaToolbar />
      </div>

      <AreaList />
    </>
  );
};

export default Areas;